export default "/assets/images/outdoor-aqi-video.9ab0a57766531d4d.mp4";